import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import { AppDisbatch } from "../../../contexts/app";
import { TypesValue } from "../../../contexts/types";
import { makeid } from "../../../utils/pageactions";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";

export default function CustomProps({ block, path, onChange }) {
  const [variables, setVariables] = useState([]);
  const disbatch = useContext(AppDisbatch);

  useEffect(() => {
    if (block.stateVariables) {
      setVariables(block.stateVariables);
    }
  }, [block.stateVariables]);

  const handleChange = (variables) => {
    const newBlock = { ...block };
    newBlock.stateVariables = variables;
    onChange(newBlock);
  };

  const handleAdd = () => {
    const id = makeid(16);
    const newVariables = [...variables];
    newVariables.push({
      value: id,
      displayName: "",
      type: "Text",
      list: false,
    });
    setVariables(newVariables);
    handleChange(newVariables);
  };

  const handleUpdate = (v, i) => {
    const newVariables = [...variables];
    newVariables[i] = v;
    setVariables(newVariables);
    handleChange(newVariables);
  };

  const handleDelete = (i) => {
    const newVariables = [...variables];
    newVariables.splice(i, 1);
    setVariables(newVariables);
    handleChange(newVariables);
  };
  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className={styles.propInput}
    >
      <div className={styles.propTitle}>State Variables</div>
      {variables.map((v, index) => {
        return (
          <VariableItem
            id={v.value}
            value={v}
            key={v.value}
            onDelete={() => handleDelete(index)}
            onChange={(v) => handleUpdate(v, index)}
          />
        );
      })}
      <div onClick={handleAdd} className={styles.addProp}>
        Add Variable
      </div>
    </div>
  );
}

const VariableItem = ({ value, id, onChange, onDelete }) => {
  const [name, setName] = useState(value.displayName);
  const types = useContext(TypesValue);

  const changeName = () => {
    const newValue = { ...value };
    newValue.displayName = name;
    onChange(newValue);
  };

  const changeType = (v) => {
    const newValue = { ...value };
    newValue.type = v;
    onChange(newValue);
  };

  const changeList = () => {
    const newValue = { ...value };
    newValue.list = !value.list;
    onChange(newValue);
  };
  return (
    <div className={styles.propItem}>
      <div>
        <div className={styles.propName}>Variable Name</div>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={"input"}
          onBlur={changeName}
        />
      </div>
      <div style={{ display: "flex", marginTop: 8 }}>
        <div style={{ flexGrow: 1, marginRight: 12 }}>
          <div className={styles.propName}>Variable Type</div>
          <select
            value={value.type}
            onChange={(e) => changeType(e.target.value)}
            className={"dropdown"}
          >
            {types.map((t) => {
              return <option value={t.name}>{t.displayName}</option>;
            })}
          </select>
        </div>
        <div style={{ minWidth: 48 }}>
          <div className={styles.propName}>List?</div>
          {value.list ? (
            <MdCheckBox onClick={changeList} className={styles.checkbox} />
          ) : (
            <MdCheckBoxOutlineBlank
              onClick={changeList}
              className={styles.checkbox}
            />
          )}
        </div>
      </div>
      <div onClick={onDelete} className={styles.delete}>
        Delete
      </div>
    </div>
  );
};
